<ng-container *ngIf="(numberOfItems$ | async) as numberOfItems">
	<div class="">
		<button mat-fab [@highlighted]="isHighlighted" (click)="openShoppingCart.emit()" class="mat-elevation-z10 mat-headline-6"
						color="primary">
			<mat-icon [matBadge]="numberOfItems" [matBadgeHidden]="numberOfItems < 1" matBadgeColor="accent"
								matBadgePosition="below before" matBadgeOverlap="false" class="app-shopping-cart-toggle__icon"
								fontSet="voest-icons__cart"></mat-icon>
		</button>
	</div>
</ng-container>
